import React, { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../../components/ui/dialog';
import { Plus, Trash2, Clock, Zap, ToggleLeft, ToggleRight } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DAYS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

export const HappyHourTab = ({ happyHours = [], categories = [], onRefresh }) => {
  const [newHH, setNewHH] = useState({
    name: '', start_time: '16:00', end_time: '19:00', discount_percent: 50, day_of_week: [], category_ids: []
  });

  const createHH = async () => {
    if (!newHH.name) return;
    try {
      await axios.post(`${API}/admin/happy-hours`, newHH);
      setNewHH({ name: '', start_time: '16:00', end_time: '19:00', discount_percent: 50, day_of_week: [], category_ids: [] });
      onRefresh();
    } catch (e) { console.error(e); }
  };

  const toggleHH = async (id) => {
    try {
      await axios.patch(`${API}/admin/happy-hours/${id}/toggle`);
      onRefresh();
    } catch (e) { console.error(e); }
  };

  const deleteHH = async (id) => {
    if (!window.confirm('Supprimer ce happy hour ?')) return;
    try {
      await axios.delete(`${API}/admin/happy-hours/${id}`);
      onRefresh();
    } catch (e) { console.error(e); }
  };

  const toggleDay = (d) => {
    setNewHH(prev => ({
      ...prev,
      day_of_week: prev.day_of_week.includes(d)
        ? prev.day_of_week.filter(x => x !== d)
        : [...prev.day_of_week, d]
    }));
  };

  const toggleCat = (catId) => {
    setNewHH(prev => ({
      ...prev,
      category_ids: prev.category_ids.includes(catId)
        ? prev.category_ids.filter(x => x !== catId)
        : [...prev.category_ids, catId]
    }));
  };

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-2xl p-4 border border-[#E5DCD3]">
        <h3 className="font-semibold text-[#2D241D] mb-1 flex items-center gap-2">
          <Zap className="w-4 h-4 text-[#E16833]" /> Happy Hours automatiques
        </h3>
        <p className="text-xs text-[#6E5E52] mb-4">Les prix sont reduits automatiquement pendant les heures definies</p>

        <Dialog>
          <DialogTrigger asChild>
            <Button className="w-full bg-[#E16833] hover:bg-[#C95A2A] text-white rounded-xl" data-testid="add-hh-btn">
              <Plus className="w-4 h-4 mr-2" /> Nouveau Happy Hour
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-md bg-white rounded-3xl admin-theme" style={{maxHeight:'85vh',overflow:'auto'}}>
            <DialogHeader><DialogTitle className="text-[#2D241D]">Nouveau Happy Hour</DialogTitle></DialogHeader>
            <div className="space-y-4 p-4">
              <div>
                <label className="text-sm font-medium text-[#2D241D] mb-1 block">Nom</label>
                <Input value={newHH.name} onChange={e => setNewHH({...newHH, name: e.target.value})}
                  placeholder="Cocktail Hour" className="rounded-xl border-[#E5DCD3]" data-testid="hh-name" />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="text-sm font-medium text-[#2D241D] mb-1 block">Debut</label>
                  <Input type="time" value={newHH.start_time} onChange={e => setNewHH({...newHH, start_time: e.target.value})}
                    className="rounded-xl border-[#E5DCD3]" data-testid="hh-start" />
                </div>
                <div>
                  <label className="text-sm font-medium text-[#2D241D] mb-1 block">Fin</label>
                  <Input type="time" value={newHH.end_time} onChange={e => setNewHH({...newHH, end_time: e.target.value})}
                    className="rounded-xl border-[#E5DCD3]" data-testid="hh-end" />
                </div>
              </div>
              <div>
                <label className="text-sm font-medium text-[#2D241D] mb-1 block">Reduction (%)</label>
                <Input type="number" value={newHH.discount_percent} onChange={e => setNewHH({...newHH, discount_percent: parseInt(e.target.value) || 0})}
                  className="rounded-xl border-[#E5DCD3] w-24" data-testid="hh-discount" />
              </div>
              <div>
                <label className="text-sm font-medium text-[#2D241D] mb-2 block">Jours (vide = tous les jours)</label>
                <div className="flex flex-wrap gap-2">
                  {DAYS.map((d, i) => (
                    <button key={i} type="button" onClick={() => toggleDay(i)}
                      className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${newHH.day_of_week.includes(i) ? 'bg-[#0A422D] text-white' : 'bg-[#F3EDE5] text-[#6E5E52]'}`}>
                      {d}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <label className="text-sm font-medium text-[#2D241D] mb-2 block">Categories (vide = toutes)</label>
                <div className="flex flex-wrap gap-2">
                  {categories.map(cat => (
                    <button key={cat.id} type="button" onClick={() => toggleCat(cat.id)}
                      className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${newHH.category_ids.includes(cat.id) ? 'bg-[#E16833] text-white' : 'bg-[#F3EDE5] text-[#6E5E52]'}`}>
                      {cat.name_fr || cat.name}
                    </button>
                  ))}
                </div>
              </div>
              <Button onClick={createHH} disabled={!newHH.name}
                className="w-full bg-[#0A422D] hover:bg-[#083323] text-white rounded-xl" data-testid="save-hh-btn">
                Creer le Happy Hour
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* List */}
      <div className="space-y-3">
        {happyHours.map(hh => (
          <div key={hh.id} className={`bg-white rounded-2xl p-4 border ${hh.is_active ? 'border-[#E5DCD3]' : 'border-red-200 opacity-60'}`}
            data-testid={`hh-card-${hh.id}`}>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <Zap className={`w-4 h-4 ${hh.is_active ? 'text-[#E16833]' : 'text-gray-400'}`} />
                <span className="font-semibold text-[#2D241D]">{hh.name}</span>
              </div>
              <div className="flex items-center gap-1">
                <button onClick={() => toggleHH(hh.id)} className="p-1" data-testid={`toggle-hh-${hh.id}`}>
                  {hh.is_active ? <ToggleRight className="w-6 h-6 text-[#2D6A4F]" /> : <ToggleLeft className="w-6 h-6 text-gray-400" />}
                </button>
                <button onClick={() => deleteHH(hh.id)} className="p-1 text-red-400 hover:text-red-600" data-testid={`delete-hh-${hh.id}`}>
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
            <div className="flex flex-wrap gap-2 text-xs text-[#6E5E52]">
              <span className="flex items-center gap-1 bg-[#F3EDE5] px-2 py-1 rounded-full">
                <Clock className="w-3 h-3" /> {hh.start_time} - {hh.end_time}
              </span>
              <span className="bg-[#E16833]/10 text-[#E16833] px-2 py-1 rounded-full font-semibold">
                -{hh.discount_percent}%
              </span>
              {hh.day_of_week?.length > 0 ? (
                hh.day_of_week.map(d => (
                  <span key={d} className="bg-[#0A422D]/10 text-[#0A422D] px-2 py-1 rounded-full">{DAYS[d]}</span>
                ))
              ) : (
                <span className="bg-[#0A422D]/10 text-[#0A422D] px-2 py-1 rounded-full">Tous les jours</span>
              )}
            </div>
          </div>
        ))}
        {happyHours.length === 0 && (
          <div className="text-center py-8 text-[#6E5E52]">
            <Zap className="w-10 h-10 mx-auto mb-2 opacity-30" />
            <p>Aucun Happy Hour defini</p>
          </div>
        )}
      </div>
    </div>
  );
};
